import { Field, getIn } from 'formik';
import { FormSwitcherFormType, FormSwitcherType } from '../../types';
import { FunctionComponent, useEffect, useState } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const FormSwitcher: FunctionComponent<FormSwitcherType> = ({
  setInitialValues,
  setValidationSchema,
  setOnSubmit,
  setCardTitle = null,
  formikProps,
  formikFieldName,
  forms,
}) => {
  const { t } = useTranslation();
  const [selectedForm, setSelectedForm] = useState<FormSwitcherFormType>();

  useEffect(() => {
    const form = forms.find((form: FormSwitcherFormType) => form.label === getIn(formikProps.values, formikFieldName));
    setSelectedForm(form);
    setCardTitle && setCardTitle(t('label.busca_de', { tipoBusca: form?.label }));
    setInitialValues(form?.initialValues);
    setValidationSchema(form?.validationSchema);
    setOnSubmit(() => form?.onSubmit);
  }, [getIn(formikProps.values, formikFieldName)]);

  return (
    <div className="pb-3">
      <ul className="list-group">
        {forms.map((form: any, index: number) => (
          <label
            className={classNames(
              'list-group-item',
              getIn(formikProps.values, formikFieldName) === form.label && 'list-group-item-primary',
            )}
            key={`radio-${formikFieldName}-${index}`}
          >
            <div className="form-check">
              <Field
                type="radio"
                name={formikFieldName}
                value={form.label}
                className="form-check-input"
                disabled={formikProps.isSubmitting || formikProps.isValidating}
              />
              {form.label}
            </div>
          </label>
        ))}
      </ul>
      {selectedForm?.descricao && (
        <div className="alert alert-info mt-2 mb-2" dangerouslySetInnerHTML={{ __html: selectedForm?.descricao }} />
      )}
      {selectedForm?.form && <selectedForm.form formikProps={formikProps} {...selectedForm?.props} />}
    </div>
  );
};

export default FormSwitcher;
